import React, { useState } from 'react';
import { ArrowRightIcon, ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
import { LinkButton } from './ui/Button';
import { Pill } from './ui/Pill';
import { waLink } from '../utils/whatsapp';
export function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);
  return <section id="faq" className="bg-ivory py-12 lg:py-20" aria-labelledby="faq-title" data-id="element-6" data-mp="1ge8uil99ubrf">
      <div className="mx-auto grid max-w-shell gap-10 px-5 lg:grid-cols-[40fr_60fr] lg:gap-16 lg:px-[120px]" data-id="element-7" data-mp="2dz4w3xjyf0dq">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-8" data-mp="291w9nkrrwa6o">
          <Pill data-id="element-9" data-mp="241qp0ojx7ny3">Resolvemos tus dudas</Pill>
          <h2 id="faq-title" className="mt-5 font-display text-[26px] font-bold leading-[1.2] text-ink lg:text-[32px]" data-id="element-10" data-mp="240fbhx0ob1ts">
            Preguntas frecuentes antes de agendar.
          </h2>
          <p className="mt-4 font-sans text-[16px] leading-[1.6] text-muted" data-id="element-11" data-mp="snwdmkw1t4op">
            Si tienes una pregunta que no está aquí, escríbenos directamente.
          </p>
          <LinkButton variant="outline" href={waLink('Hola, tengo una pregunta antes de agendar.')} target="_blank" rel="noreferrer" className="mt-6" data-id="element-12" data-mp="phefvtbtcvb4">
            Escribir por WhatsApp
            <ArrowRightIcon className="h-4 w-4" data-id="element-13" data-mp="fluo9j4a8is6" />
          </LinkButton>
        </div>

        <ul data-id="element-14" data-mp="kh0a6hxopxg9">
          {faqs.map(faq => {
          const isOpen = openId === faq.id;
          return <li key={faq.id} className={`mb-2 rounded-xl bg-white transition-all duration-200 ${isOpen ? 'border border-secondary shadow-soft' : 'border border-hairline'}`} data-id="element-15" data-mp="6pdfgmje4wzl">
                <h3 data-id="element-16" data-mp="1t529eor7dv2">
                  <button type="button" onClick={() => setOpenId(isOpen ? null : faq.id)} aria-expanded={isOpen} aria-controls={`faq-panel-${faq.id}`} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left" data-id="element-17" data-mp="1smy7vvunvcl">
                    <span className="font-sans text-[16px] font-semibold text-ink" data-id="element-18" data-mp="1ppmbaurkcgar">{faq.question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-secondary transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-19" data-mp="1kq9qsgo5zlbc" />
                  </button>
                </h3>
                {isOpen && <div id={`faq-panel-${faq.id}`} className="px-6 pb-5" data-id="element-20" data-mp="28hnkor1yroyf">
                    <p className="font-sans text-[15px] leading-[1.6] text-muted" data-id="element-21" data-mp="23gzto5dqj847">{faq.answer}</p>
                    {faq.clientData && <Pill tone="amber" className="mt-3 text-[11px]" data-id="element-22" data-mp="1zfe87vn4xlie">
                        Dato real del cliente
                      </Pill>}
                  </div>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}